import { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiMenu, FiX, FiPhone } = FiIcons;
const links = [
  ['Programs', '#programs'],
  ['Showcase', '#showcase'],
  ['Schedule', '#schedule'],
  ['Story', '#story'],
  ['Coaches', '#coaches'],
  ['Memberships', '#memberships'],
  ['Gallery', '#gallery'],
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={scrolled ? 'site-header scrolled' : 'site-header'}>
      <a href="#top" className="brand" aria-label="Forge Fitness home">
        <span className="brand-mark">F<span>.</span></span>
        <span className="brand-name">FORGE <small>FITNESS CLUB</small></span>
      </a>
      <button
        className="menu-toggle"
        type="button"
        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <SafeIcon icon={menuOpen ? FiX : FiMenu} />
      </button>
      <nav className={menuOpen ? 'main-nav is-open' : 'main-nav'} aria-label="Main navigation">
        {links.map(([label, href]) => (
          <a key={label} href={href} onClick={() => setMenuOpen(false)}>{label}</a>
        ))}
        <a className="nav-cta" href={waLink()} target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>
          <SafeIcon icon={FiPhone} /> Contact Us
        </a>
      </nav>
    </header>
  );
}
export default Header;
